module.exports = __webpack_public_path__ + "assets/img/mecha-77baabfc.png";